
<template>
    <div class="com-feature">
        <div class="com-feature-wrapper container">		
            <div class="com-title">8大系统特色<label>eight major system features</label></div>	
            <ul class="com-feature__items block">
                <li class="com-feature__item">
                    <img src="@/assets/td-1.jpg">
                    <b>免费使用</b>免费提供有寄系统，您只需做好线下服务，让专业的人做专注的事
                </li>	
                <li class="com-feature__item">
                    <img src="@/assets/td-2.jpg">
                    <b>有寄线路</b>有寄提供优质价廉的线路服务，覆盖英国常用线路，丰富的线路供应拓展商家服务边界
                </li>	
                <li class="com-feature__item">
                    <img src="@/assets/td-3.jpg">
                    <b>商家线路</b>有寄免费对接商家线路，每个商家独有的个性化依然被保留
                </li>	
                <li class="com-feature__item">
                    <img src="@/assets/td-4.jpg">
                    <b>多支付方式</b>提供多种支付方式，stripe、worldpay、sagepage、微信支付、支付宝，银行转账等
                </li>	
                <li class="com-feature__item">
                    <img src="@/assets/td-5.jpg">
                    <b>批量下单</b>单次1000单订单导入，日处理10W量级高效稳定系统，还有什么比高效更重要
                </li>
                <li class="com-feature__item">
                    <img src="@/assets/td-6.jpg">
                    <b>自动充值</b>“先服务后付款”有寄独创智能信用支付，高速下单全程无忧
                </li>
                <li class="com-feature__item">
                    <img src="@/assets/td-7.jpg">
                    <b>财务管理</b>总览全局的财务罗盘，每天进账支出一目了然，运筹帷幄皆在掌握
                </li>
                <li class="com-feature__item">
                    <img src="@/assets/td-8.jpg">
                    <b>持续升级</b>紧跟行业发展，有寄系统不定期更新服务，各业务模块持续升级中
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-feature'
}
</script>

<style lang="less" scoped>
    .com-feature {
        &__items {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        &__item {
            width: 22%;
            line-height: 1.44;
            img {
                width: 100%;
                border-radius: .08rem;
            }
            b {
                display: block;
                margin: .2rem 0;
                font-size: .25rem;
            }
            &:nth-child(-n+4) {
                margin-bottom: .4rem;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .com-feature {
            &-wrapper {
                padding: 0 .3rem;
                box-sizing: border-box;
            }
            &__item {
                width: 100%;
                margin-bottom: .4rem;
                img {
                    float: left;
                    width: 30%;
                    margin-right: .4rem;
                }
                b {
                    margin: 0;
                    font-size: .42rem;
                    font-weight: normal;
                }
            }
        }
    }
</style>

